import { isAgeWithinRange } from './patient-age-range.util';

import { AuthenticatedUser, Dependent } from '@/types/auth-base.types';
import { PatientOption, PatientType, ScheduleAgeRange } from '@/types/patient-selection.types';
import { getAgeFromBirthday } from '@/utils/formatters/date';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

type PatientSource = Pick<Dependent, 'id' | 'legalName' | 'socialName' | 'documentNumber' | 'birthday'>;

const resolveAge = (birthday: string | undefined): number | undefined => {
  if (!birthday) {
    return undefined;
  }

  const age = getAgeFromBirthday(birthday);

  return Number.isFinite(age) ? age : undefined;
};

const toOption = (patient: PatientSource, type: PatientType, range: ScheduleAgeRange): PatientOption => {
  const age = resolveAge(patient.birthday);

  return {
    id: patient.id,
    name: formatToTitleCase(patient.socialName || patient.legalName),
    documentNumber: patient.documentNumber,
    age,
    type,
    isWithinAgeRange: isAgeWithinRange(age, range),
  };
};

export function buildPatientOptions(
  user: AuthenticatedUser | undefined,
  range: ScheduleAgeRange,
): PatientOption[] {
  if (!user) {
    return [];
  }

  const holder = toOption({ ...user, id: user.id ?? '' }, PatientType.HOLDER, range);
  const dependents = (user.dependents ?? []).map((dependent) => toOption(dependent, PatientType.DEPENDENT, range));

  return [holder, ...dependents];
}
